module.exports = __webpack_public_path__ + "img/add-list.4f67522d.svg";